import Message from "types/Message";

/** Ensure listKey is set (API may omit it for legacy rows). */
export function ensureMessageListKey(message: Message): Message {
  return {
    ...message,
    listKey: message.listKey ?? String(message.id),
  };
}

export function isOptimisticMessage(message: Message): boolean {
  return message.id < 0;
}

export function upsertWebsocketMessage(
  prev: Message[],
  message: Message
): Message[] {
  const existingIndex = prev.findIndex((m) => m.listKey === message.listKey);
  if (existingIndex !== -1) {
    const next = [...prev];
    next[existingIndex] = message;
    return next;
  }
  return [message, ...prev].sort(
    (a, b) => Date.parse(b.sentAt) - Date.parse(a.sentAt)
  );
}
